module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAIAAABwJOjsAAAA80lEQVRIx2OYIuWhoN7AoNVPb3ReRPu0iG6xXDiPZie9LYagfWLGwYrpTFp99LYYglZI2Bmrlg2AxRB0P6no56On/2kJsFsMRBeljZ61Tfr79Ru9LYagK7qO71Zv/v/vH80tflzSeEFCD03wlmfU13OXaWvx9+u374SmYnr9nIh2o0ygsEYb9RPXy4lz/rz/CHLM37/frt684RSKaf1RUYMkhXg2zR4qp+pX0xYA7f335+9FeVOsUX5cVD9TPoad6hZ/PnTiSVX7l1Pn70Zl0S+ogeiaiQcag36Ja8Cy0wAXIANQZA5AJTEA1eLANAQGqukDAB69qg8i0mkvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/cu.png
// module id = 801
// module chunks = 0